export default "__VITE_PUBLIC_ASSET__f028d8c3__"